import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
const userSelect = (user) => {
  let arr = Array.from(Array(15).keys(), (x) => x + 1);
  arr = arr.map((val) => ({
    id: "u_" + val,
    name: val + " " + (val == 1 ? user : user + "s"),
  }));
  return arr;
};
const creditSelect = (credits) => {
  let arr = Array.from(Array(15).keys(), (x) => (x + 1) * 50);
  arr = arr.map((val, i) => ({
    id: "c_" + (i + 1),
    name: val + " " + credits,
    enterpriseCredits: 0,
  }));
  return arr;
};

export default function useSimulatorSelect({
  simulationType,
  subscriptionType,
  onChange,
}) {
  const intl = useIntl();
  const [currentValues, setCurrentValues] = useState(
    userSelect(intl.formatMessage({ id: "user" }))
  );
  const [selectedByUser, setSelectedByUser] = useState(
    userSelect(intl.formatMessage({ id: "user" }))[0]
  );
  const [selectedByCredits, setSelectedByCredits] = useState(
    creditSelect(intl.formatMessage({ id: "credits" }))[0]
  );
  useEffect(() => {
    if (simulationType === "by_user") {
      //setSelectedByUser(userSelect()[0]);
      setCurrentValues(userSelect(intl.formatMessage({ id: "user" })));
    } else {
      // setSelectedByCredits(creditSelect()[0]);
      setCurrentValues(creditSelect(intl.formatMessage({ id: "credits" })));
    }
    onChange({
      id:
        simulationType === "by_user" ? selectedByUser.id : selectedByCredits.id,
      type: simulationType,
    });
  }, [simulationType]);

  useEffect(() => {
    if (simulationType === "by_user") {
      setCurrentValues(userSelect(intl.formatMessage({ id: "user" })));
    } else {
      setCurrentValues(creditSelect(intl.formatMessage({ id: "credits" })));
    }
    onChange({
      id:
        simulationType === "by_user" ? selectedByUser.id : selectedByCredits.id,
      type: simulationType,
    });
  }, [subscriptionType]);

  const onSelectChange = (id) => {
    if (simulationType === "by_user")
      setSelectedByUser(currentValues.find((v) => v.id == id));
    else setSelectedByCredits(currentValues.find((v) => v.id == id));
  };
  return {
    state: { currentValues, selectedByUser, selectedByCredits },
    setter: { setCurrentValues, setSelectedByUser, setSelectedByCredits },
    handler: { onSelectChange },
  };
}
